import { KatButton, KatModal } from '@amzn/katal-react';
import React from 'react';
import { BulkR2FModalProps } from '../../types/bulkR2fTypes';

export const R2FConfirmationModal: React.FC<BulkR2FModalProps> = ({
    isOpen,
    onClose,
    pendingChanges,
    uploadedData,
    onConfirm,
    isUploading
}) => (
    <KatModal
        visible={isOpen}
        title="Confirm R2F Threshold Changes"
        onClose={onClose}
    >
        <div>
            <h4>The following R2F threshold changes will be applied:</h4>
            <table>
                <thead>
                    <tr>
                        <th>Warehouse</th>
                        <th>Production Capability</th>
                        <th>Handling Tier</th>
                        <th>Current Low</th>
                        <th>Current High</th>
                        <th>New Low</th>
                        <th>New High</th>
                    </tr>
                </thead>
                <tbody>
                    {pendingChanges.map((change, index) => {
                        const originalRow = uploadedData.find(
                            row => row.warehouseId === change.warehouseId &&
                                row.productionCapability === change.productionCapability &&
                                row.handlingTier === change.handlingTier
                        );
                        return (
                            <tr key={index}>
                                <td>{change.warehouseId}</td>
                                <td>{change.productionCapability}</td>
                                <td>{change.handlingTier}</td>
                                <td>{originalRow?.currentLowThreshold || '—'}</td>
                                <td>{originalRow?.currentHighThreshold || '—'}</td>
                                <td>{change.lowThreshold !== undefined ? change.lowThreshold : '—'}</td>
                                <td>{change.highThreshold !== undefined ? change.highThreshold : '—'}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                <KatButton
                    variant="primary"
                    onClick={onConfirm}
                    disabled={isUploading}
                >
                    Confirm Changes
                </KatButton>
                <KatButton
                    variant="secondary"
                    onClick={onClose}
                >
                    Cancel
                </KatButton>
            </div>
        </div>
    </KatModal>
);
